module.exports = __webpack_public_path__ + "../../static/vue/img/swimstats_live_icon_512.d8c42205.jpg";